export const asyncRouterMap = [
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/',
    name: 'home',
    component: {
      template:'<router-view />'
    },
    redirect: { name: 'home' },
    children: [
      { path: 'home', name: 'home', meta: { title: '首页' }, component: () => import(/* webpackChunkName: "layout" */ '@/views/About') },
      { path: '/realtime', name: 'realtime', meat: { title: '实时监控' }, component: () => import(/* webpackChunkName: "realtime" */ '@/views/realtime') },
      { path: '/realtime/playbackList', name: 'realtime-playbackList', meat: { title: '实时监控列表' }, component: () => import(/* webpackChunkName: "realtime" */ '@/views/realtime/playbackList') },
      { path: '/realtime/trackPlayback', name: 'realtime-trackPlayback', meat: { title: '轨迹回放' }, component: () => import(/* webpackChunkName: "realtime" */ '@/views/realtime/trackPlayback') },
      { path: '/carReport',name:'carReport',meta:{title:'汽车报表'},component:()=>import(/* webpackChunkName: "carReport" */ '@/views/vehicleReport/report')},
      { path: '/consulte',name:'consulte',meta:{title:'资讯'},component:()=>import(/* webpackChunkName: "consulte" */ '@/views/consulte/index')},
      { path: '/detail',name:'detail',meta:{title:'资讯详情'},component:()=>import(/* webpackChunkName: "consulte" */ '@/views/consulte/consultDetail')},
      { path: '/guide/userGuide',name:'guide-userGuide',meta:{title:'用户指南'},component:()=>import(/* webpackChunkName: "guide" */ '@/views/guide/userGuide/index')},    
      { path: '/equipment/equipmentList',name:'equipment-equipmentList',meta:{title:'设备大全'},component:()=>import(/* webpackChunkName: "equipment" */ '@/views/equipment/equipmentList/index')},    
      { path: '/login',name:'login',meta:{title:'登录'},component:()=>import(/* webpackChunkName: "login" */ '@/views/login/index')},
      { path: '/login/success',name:'login-success',meta:{title:'登录成功'},component:()=>import(/* webpackChunkName: "login" */ '@/views/login/success')},

    ]
  },
]
